import { render, staticRenderFns } from "./PromoMod.vue?vue&type=template&id=12fd2f96"
import script from "./PromoMod.vue?vue&type=script&lang=js"
export * from "./PromoMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports